import { TicketOfficeView } from '../../../types/ticket-office';
import { Seats } from '../../../types/types';
import { TicketTypeRow, TicketTypesTableProps } from '../../components/TicketTypesTable';
import { formatPrice } from '../../number-utils';
import { addUnnumberedSeat, getSeatQuantityInputProps } from './seat-utils';
import { getTicketsTableProps } from './TicketsTable';

export const getTicketTypesTableProps = (
    view: TicketOfficeView,
    seatsByType: Record<string, Seats>,
): TicketTypesTableProps => {
    const { state, update } = view;
    const { currencySymbol, lang, ticketTypes, expandedTicketTypes } = state;
    const isExpandable = Boolean(state.floorplanData);

    const props: TicketTypesTableProps = {
        headers: {
            type: lang.tickets.type,
            price: lang.common.price,
            quantity: lang.common.quantity,
        },
        rows: [],
        isExpandable,
    };

    for (const type of ticketTypes) {
        const seats = seatsByType[type.id];
        const isExpanded = expandedTicketTypes.has(type.id);

        const row: TicketTypeRow = {
            summary: {
                ticketType: type.name,
                price: formatPrice(parseFloat(type.price), currencySymbol),
                quantityInput: getSeatQuantityInputProps(view, seatsByType, type),
                isExpanded,
            },
        };

        if (isExpandable) {
            row.rowProps = {
                onClick: (): void => {
                    if (isExpanded) {
                        expandedTicketTypes.delete(type.id);
                    } else {
                        expandedTicketTypes.add(type.id);
                    }

                    update();
                },
            };
        }

        props.rows.push(row);

        if (isExpanded) {
            props.rows.push({
                details: {
                    table: getTicketsTableProps(view, seats),
                    addLink: {
                        children: `+ ${lang.tickets.addExtraSeat}`,
                        onClick: (): void => void addUnnumberedSeat(view, type.id),
                    },
                },
            });
        }
    }

    return props;
};
